import React from 'react';
import { InsidePagesCarousel } from '../InsidePagesCarousel';
import { SectionHeading } from './SectionHeading';
export function InsideSection() {
  return <section aria-labelledby="inside-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-20" data-id="element-123" data-mp="2lz7ysq8p4ia3">
      <div className="mx-auto max-w-6xl" data-id="element-124" data-mp="2h424p4553xax">
        <SectionHeading id="inside-heading" title="Ne nous croyez pas sur parole. Regardez ce qu’il y a à l’intérieur." body="De véritables ressources conçues pour être utilisées dans vos formations." data-id="element-125" data-mp="2d5mk16wj710o" />

        <div className="mt-12" data-id="element-126" data-mp="235cabw9pgbq9">
          <InsidePagesCarousel data-id="element-127" data-mp="1y7ao52gzfwak" />
        </div>
      </div>
    </section>;
}